export const getUserRole = () => {
    return window.localStorage.userRole;
}
export const isB2B = (): boolean => {
    return typeof getUserRole() !== "undefined";

}
